<template>
  <div class="chart-container">
    <div class="chart-main-container">
      <chart ref="chart" chartType="line" chartId="WeeklyChart" :width="size === 'mini' ? 300 : 836"
             :height="size === 'mini' ? 180 : 400"></chart>
    </div>
  </div>
</template>

<script lang="js">
import { GraphLineColorSet } from '../../defines/chart-color'
import ChartCmp from './base.vue'

export default {
  name: 'YearlyChartCmp',
  components: {
    'chart': ChartCmp
  },
  props: {
    yearlyComparison: {type: Object, default: () => {}},
    size: '',
    initialColumnIndex: {type: Number, default: 0}
  },
  data () {
    return {
      selectedColumnIndex: -1,
      selectedYearlyResult: null,
      colorSet: GraphLineColorSet,
      monthMap: {
        January: '1月',
        February: '2月',
        March: '3月',
        April: '4月',
        May: '5月',
        June: '6月',
        July: '7月',
        August: '8月',
        September: '9月',
        October: '10月',
        November: '11月',
        December: '12月'
      }
    }
  },
  created () {
    this.selectedColumnIndex = this.initialColumnIndex
    this.$nextTick(() => {
      this.$forceUpdate()
    })
  },
  watch: {
    selectedColumnIndex (newIndex) {
      if (newIndex < 0) return
      this.selectedYearlyResult = this.yearlyComparison.results[newIndex]
    },
    selectedYearlyResult (yearlyResult) {
      if (!yearlyResult) return

      const ds = yearlyResult.value.map(value => value.ds)
      const importance = yearlyResult.value.map(value => value.importance)
      const isMini = this.size === 'mini'
      const monthMap = this.monthMap

      let datasets = []
      datasets.push(
        Object.assign(
          {
            data: importance,
            type: 'line',
            yAxisID: 'importance',
            fill: false,
            lineTension: 0,
            pointRadius: isMini ? 0 : 3,
            pointBorderWidth: isMini ? 0 : 8
          },
          this.colorSet.red
        )
      )

      const chartData = {
        labels: ds,
        datasets: datasets
      }

      const options = {
        responsive: isMini,
        title: {
          display: false
        },
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              id: 'importance',
              position: 'left',
              type: 'linear',
              scaleLabel: {
                display: true,
                fontSize: 16
              },
              gridLines: {
                drawOnChartArea: false
              },
              ticks: {
                beginAtZero: false
              }
            }
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                fontSize: 16
              },
              ticks: {
                maxRotation: 90,
                callback: function (value, index, values) {
                  if (monthMap.hasOwnProperty(value)) {
                    return monthMap[value]
                  } else {
                    return value
                  }
                }
              }
            }
          ]
        }
      }

      this.$refs.chart.renderChart(chartData, options)
    }

  }

}

</script>

<style scoped>
  .chart-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: center;
  }

  .chart-main-container {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/chart/yearly.vue